export default __webpack_public_path__ + "static/media/los-angeles.25618387.png";